








































































import { Dialog, Toast } from 'vant';
import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';

@Component({})
export default class extends Vue {
  currentPhone: string = '';
  form = {
    Phone: '',
    VerCode: '',
  };
  show: boolean = true;
  count: number = 0;
  timer: any = null;

  get SmsType() {
    return models.SmsType;
  }

  mounted() {
    if (this.$route.query.phone) {
      this.currentPhone = this.$route.query.phone as any;
    }
  }

  async getCode() {
    if (this.form.Phone.length < 1) {
      Dialog.alert({
        title: '提示',
        message: '请输入手机号。',
      });
      return;
    }
    const result = await api.AccountApp.localSendSms_POST({
      Phone: this.form.Phone,
      Type: this.SmsType.修改手机号,
    });

    if (result.success) {
      const TIME_COUNT = 30;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    } else {
      Toast(result.message);
    }
  }

  async onSubmit() {
    try {
      const data = await api.AccountApp.updatePhone_POST(this.form);
      if (data.success) {
        Object.keys(this.form).forEach(k => {
          this.form[k] = '';
        });
        Dialog.alert({
          message: '修改成功',
          title: '提示',
        });
        this.$router.push('/personInfo/index');
      } else {
        Dialog.alert({
          message: data.message ? data.message : '修改失败',
          title: '提示',
        });
      }
      console.log('%c [ data ]-131', 'font-size:13px; background:pink; color:#bf2c9f;', data);
    } catch (error) {
      Dialog.alert({
        message: error.toString(),
        title: '提示',
      });
    }
  }
}
